<style lang="less">
	td{
		font-size: 0.74em;
	}

</style>
<template>
	<div class="pa-4">
		<v-tabs right>
		<v-tab @click="filterStatus = 'new'">New</v-tab>
		<v-tab @click="filterStatus = 'converted'">Recruited</v-tab>
		<v-tab @click="filterStatus = 'excluded'">Excluded</v-tab>
		</v-tabs>
    
		<v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="mb-5 pa-2"
		></v-text-field>
		<v-data-table
			:headers="headers"
			:items="filteredRows"
			:item-key="id"
			:items-per-page="20"
			:search="search"
			:show-select="false"
			:multi-sort="true"
			
			class="elevation-1 MwDataTable"
			>
		<template v-for="slot in projectSlots" v-slot:[`item.${slot.name}`]="{ item }">
			<!-- <div class="cellFill" :key="slot.name" v-bind:class="{ 'selected': selectedSlots[item.id] == slot.name }"  @click="setSlot(item, slot.name)" > -->
			<div class="text-center"  :key="item.id+'-'+slot.name">
				<v-icon :c="item.id+'-'+slot.name" :color="getColor(item, slot.name)"  @click="setSlot(item, slot.name)">{{ getIcon(item[slot.name]) }}</v-icon>
			</div>
			<!-- </div> -->
		</template>
		<template v-for="slot in projectSlots" v-slot:[`header.${slot.name}`]="{ header }">
			<v-tooltip :key="slot.name" top>
				<template v-slot:activator="{ on }">
					<span v-on="on" class="text-center">{{header.text}}</span>
				</template>
				<span>{{slot.date}} {{slot.startTime}} - {{slot.endTime}}</span>
			</v-tooltip>
		</template>
		<template v-slot:item.buttons="{ item }">
			<v-menu>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" icon small ><v-icon>mdi-dots-horizontal</v-icon></v-btn>
				</template>
				<v-list dense>
					<v-dialog v-model="appointmentDialog" max-width="590" >
						<template v-slot:activator="{ on }">
							<v-list-item v-if="item.type == 'panelmember'"  v-on="on">
								<v-list-item-title>Create Appointment</v-list-item-title>
							</v-list-item>
						</template>
						<ConvertCandidateToAppointment 
						:item="item" 
						:selectedSlots="selectedSlots"
						:slotInfo="projectSlots.find( p => p.name == selectedSlots[item.id])"
						:project="project"
						v-on:cancel="appointmentDialog = false"></ConvertCandidateToAppointment>
					</v-dialog>

					<v-dialog v-model="userDialog">
						<template v-slot:activator="{ on }">
							<v-list-item v-if="item.type == 'visitor'"  v-on="on">
								<v-list-item-title>Create Panel Member</v-list-item-title>
							</v-list-item>
						</template>
						<ConvertVisitorToPanelMember 
						:item="item" 
						:visitors="visitors"
						:phoneKey="phoneKey"
						:emailKey="emailKey"
						:lastNameKey="lastNameKey"
						:firstNameKey="firstNameKey"
						v-on:cancel="userDialog = false"></ConvertVisitorToPanelMember>
					</v-dialog>

					<v-dialog v-model="messageDialog">
						<template v-slot:activator="{ on }">
							<v-list-item v-if="item.type == 'panelmember'"  v-on="on">
								<v-list-item-title>Send Message</v-list-item-title>
							</v-list-item>
						</template>
						<SendCustomMessage 
						:to="[item.respondentId]" 
						:anonymous="false" 
						:from="user.uid"
						:templateMessagingParams="{project: project.id}"
						v-on:cancel="messageDialog = false"
						v-on:sent="messageDialog = false"></SendCustomMessage>
					</v-dialog>
					<v-dialog v-model="excludeDialog" persistent max-width="290">
						<template v-slot:activator="{ on }">
							<v-list-item v-on="on">
								<v-list-item-title>Exclude</v-list-item-title>
							</v-list-item>
						</template>
						<ExcludeCandidate 
						:item="item" 
						v-on:cancel="excludeDialog = false"></ExcludeCandidate>
					</v-dialog>
				</v-list>
			</v-menu>

		</template>
      <template v-slot:body.append>
        <tr>
			<td v-for="header in headers" :key="header.value">
            <v-autocomplete v-if="header.value !== 'buttons'" v-model="filters[header.value]" :items="options[header.value]" multiple chips></v-autocomplete>
          </td>
        </tr>
      </template>		
		</v-data-table>
	</div>
</template>
<script>
	import Vue from 'vue';
	import Vuex from 'vuex';
	import {processSurveyColumns, processSurveyRows } from "../../assets/surveyProcessing.js";
	import { sortByKey } from "../../assets/utilities.js";
	export default {
		name: "EditProjectCandidates", 
		props: {
			project: {type: Object}
		},
		data: () => {
			return {
				editable: false, 
				selectedSlots: {},
				filters: {},
				filterStatus: "new",
				search: '',
				appointmentDialog: false,
				excludeDialog: false,
				userDialog: false,
				messageDialog: false,
			}
		},
		components: {
			ConvertCandidateToAppointment: () => import("../edits/candidateFields/ConvertCandidateToAppointment"),
			ExcludeCandidate: () => import("../edits/candidateFields/ExcludeCandidate"),
			ConvertVisitorToPanelMember: () => import("../edits/candidateFields/ConvertVisitorToPanelMember"),
			SendCustomMessage: () => import("../tools/SendCustomMessage"),
		},
		computed:{
			...Vuex.mapState({
				user: state => state.auth.user,
				projectAvailability: function(state){
					const self = this;
					return state[state.auth.view].projectAvailability.find(a => a.id == self.project.id) 
				},
				projectSlots: function(state){
					const self = this;
					let slots = state[state.auth.view].projectSlots.find(a => a.id == self.project.id)
					if( slots ){
						let slotArr = Object.keys(slots.slots).map( key => slots.slots[key] );
						return sortByKey( slotArr , "start")
					}
					return []
				},
				screener: function(state){
					const self = this;
					return state[state.auth.view].surveys.find( a => a.id == self.project.screener )
				},
				responses: function(state){ 
					return state[state.auth.view].surveyResponses;
				},
				panelists: function(state){
					return state[state.auth.view].panelists
				},
				visitors: function(state){
					return state[state.auth.view].visitors
				}
			}),
			firstNameKey(){
				let f = this.headers.find( a => a.text == "First Name" || a.text == "Please enter your first name:" );
				if( f ){
					return f.value;
				}
				return false;
			},
			lastNameKey(){
				let l = this.headers.find( a => a.text == "Last Name" || a.text == "Please enter your last name:" );
				if( l ){
					return l.value;
				}
				return false;			
			},
			emailKey(){
				let e = this.headers.find( a => a.text == "Email" || a.text == "Please enter your email address (we will use this to contact you):" || a.text == "Email Address" );
				if( e ){
					return e.value;
				}
				return false;			
			},
			phoneKey(){
				let p = this.headers.find( a => a.text == "Phone" || a.text == "Please enter your phone number (we will use this to contact you):" || a.text == "Phone Number" );
				if( p ){
					return p.value;
				}
				return false;			
			},
			headers(){
				if( !this.screener ){
					return [];
				}
				let headers = [
					{value: "buttons", text: ""},
					{value:"type", text: "Type"},
					{value: "respondent", text: "Respondent"}, 
				];
				let slots = this.projectSlots;
				slots.forEach( slot => {
					headers.push( {
						value: slot.name, 
						text: slot.startTime,
						width: "3%"
					} )
				} )
				headers.push(
					{value:"created", text: "Created"},
				)
				let questionHeaders = processSurveyColumns(this.screener.elements, false);
				// questionHeaders = questionHeaders.filter (a => !a.excludeFromProfiles )
				headers = headers.concat( questionHeaders );
				return headers;
			}, 
			rows(){
				const self = this;
				let rows = processSurveyRows( self.responses.filter( a => a.status == self.filterStatus ), self.headers, false );
				let slots = self.projectSlots;
				rows.forEach( row => {
					let respondent	= self.panelists.find( p => p.id ==  row.respondent);
					let userProvidedProjectAvailability;
					if( respondent ){
						row.type = "panelmember";
						row.respondentId = row.respondent;
						row.respondent = respondent.displayName;
						if( respondent.availability ){
							userProvidedProjectAvailability = respondent.availability[self.project.id];
						}
					}
					else{
						row.type = "visitor";
						let visitor = self.visitors.find( v => v.id == row.respondent );
						if( visitor ){							
							if( visitor.availability ){
								userProvidedProjectAvailability = visitor.availability[self.project.id];
							}
						}
					}
					if( slots  ){
						if( userProvidedProjectAvailability ){
							slots.forEach( slot => {
								let slotAvailability = userProvidedProjectAvailability.find( a => a.name == slot.name );
								if( slotAvailability ){
									row[slot.name] = slotAvailability.availability; 
								}
								else{
									row[slot.name] = "blank";
								}
							} )		
						}
						else{
							slots.forEach( slot => {
								row[slot.name] = "none";
							})
						}
					}		
					if( row.created ){
						row.created = Vue.moment( row.created.toDate()).format("DD-MM-YYYY HH:mm") ;
					}
				})
				return rows;
			},
			filteredRows(){
				const self = this;
				let rows = self.rows;
				for( var key in self.filters){
					if( self.filters[key] && self.filters[key].length )
					rows = rows.filter( r => self.filters[key].indexOf(r[key]) > -1 )
				}
				return rows;
			},
			options(){
				const self = this;
				let options = {};
				self.headers.forEach( header => {
					options[header.value] = [];
				})
				for( var key in options ){
					var answers = self.rows.map( r => r[key] ).filter( (o, index, self) =>  self.indexOf( o ) == index );
					options[key] = answers;
				}
				return options
			}
		},
		methods:{
			getColor(item, slot){
				if( !this.selectedSlots[item.id] ){
					switch (item[slot]){
						case "available":
							return "primary";
						case "preferred":
							return "pink";
						case "unavailable":
							return "red";
						default: 
							return "#cdcdcd";
					}
				}
				else{
					if( this.selectedSlots[item.id] == slot ){
						return "green";
					}
					else{
						return "#cdcdcd";
					}
				}
			},
			getIcon(availability){
				switch (availability){
					case "available":
						return "mdi-check-circle";
					case "preferred":
						return "mdi-heart-circle";
					case "unavailable":
						return "mdi-close-circle";
					case "blank":
						return "mdi-circle-outline";
					default: 
						return "mdi-circle-outline";
				}
			},
			setSlot( item, slot ){
				let currentSlots = {...this.selectedSlots};
				currentSlots[item.id] = slot;
				this.selectedSlots = currentSlots;
			}
		},
		watch: {
			project: {
				immediate: true,
				handler: function(){
					if( this.project.screener ){					
						this.$store.dispatch("fetchSurvey", this.project.screener )
					}
					if( this.project.screener ){					
						this.$store.dispatch("fetchSurveyResponses", this.project.screener )
					}
					if( this.project.id ){
						this.$store.dispatch("fetchProjectSlots", this.project.id )
					}

				}
			}
		}
	}
</script>